// extracted by mini-css-extract-plugin
export default {"wrap":"rF-z","fullWidth":"sF-z","hideOnDesktop":"tF-z","content":"uF-z","hasOpenedNav":"vF-z","crumbsList":"wF-z","dropdownsWrap":"xF-z"};